import { MessageCircle } from "lucide-react";

import { GoLink } from "@/features/platform/components/landing-ui";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/** Where the help centre runs out: one line, and the way to a person. `compact` for the column beside an article. */
export const StillStuck = ({ compact = false }: { compact?: boolean }) => (
  <div
    className={cn(
      "relative isolate flex overflow-hidden rounded-[28px] bg-[var(--site-wash)]",
      compact ? "flex-col gap-5 p-6" : "mt-16 flex-col justify-between gap-6 p-7 md:mt-[104px] md:flex-row md:items-center md:p-10",
    )}
  >
    <div className="flex gap-4">
      <span className="grid size-11 shrink-0 place-items-center rounded-2xl bg-background text-[var(--site-ink)]">
        <MessageCircle aria-hidden className="size-5" />
      </span>
      <div>
        <h2 className={cn("font-medium tracking-[-0.03em]", compact ? "text-lg" : "text-[clamp(1.4rem,2.4vw,1.85rem)] leading-[1.1]")}>
          {m.help_stuck_title()}
        </h2>
        <p className="mt-1.5 max-w-[48ch] text-[15px] leading-normal text-muted-foreground">{m.help_stuck_body()}</p>
      </div>
    </div>
    <GoLink to="/contact" className="shrink-0">
      {m.help_stuck_cta()}
    </GoLink>
  </div>
);
